import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

// Scroll to top on route (page) changes, but NOT when only the language changes.
// We compare the path with the language prefix stripped: if the underlying page is
// the same (e.g. /ar/privacy -> /en/privacy), it is a language switch -> no scroll.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  const prevRef = useRef(pathname);

  useEffect(() => {
    const strip = (p) => p.replace(/^\/(ar|en)(?=\/|$)/, '');
    const prevStripped = strip(prevRef.current);
    const currStripped = strip(pathname);
    if (prevStripped !== currStripped) {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }
    prevRef.current = pathname;
  }, [pathname]);

  return null;
}
